import { useRef } from 'react'


// Custom hook to use a ref as state
// This is useful when you want to keep a value between renders, but don't want to trigger a re-render when it changes
export const useRefAsState = (initialValue) => {
    // Support lazy initialization if initialValue is a function
    const ref = useRef(
        typeof initialValue === 'function' ? initialValue() : initialValue
    );
    return [ref, (newValue) => ref.current = newValue];
}
